module.exports = __webpack_public_path__ + "media/mode_circulaire/arrow-3_1-2ccd8474.png";